<template>
  <div v-bind:class="{ page__home: true }">
    <div id="home_wall"></div>
  </div>
</template>

<script>
import vx_api from "../vuemix";
import { sync } from "vuex-pathify";
import store from "../store";
import crinfo from '@/cr.js'

export default {
  name: "home",
  components: {},
  created() {
    // eslint-disable-next-line 
    //console.log("home created");
    window.vx_clr_room(window.vx);
    document.title = "Home";
    this.addLegacyScripts();
  },
  mounted() {
    window.vx_clr_room(window.vx);
    document.title = "Home";
    this.$parent.set_room_background();
    vxslog({p:"home",a:"open"});
  },
  data() {
    return {
      vxScript: process.env.BASE_URL + "legacy/js/home.js"
    };
  },
  methods: {
    hasBridge() {
      return this.$parent.mydevice.has_bridge;
    },
    addLegacyScripts: function() {
      this.$loadScript(this.vxScript)
        .then(() => {
          if (this.$route.name != "home") {
            /* Route can change before JS loaded. Proceeding
               will kill wss/player for Room. */
            // eslint-disable-next-line 
            console.log("home no longer active");
            return;
          }
          window.vxHome.start({onDoubleTap: this.onDoubleTap,
                               crinfo: crinfo});
        })
        .catch(() => {
          // Failed to fetch script
        });
    },
    removeLegacyScripts: function() {
      this.$unloadScript(this.vxScript)
        .then(() => {
          // eslint-disable-next-line 
          //console.log("home unloaded");
        })
        .catch(() => {
          // Failed to fetch script
        });
    },
    onDoubleTap: function(wall, ct, tag, index) {
      //console.log(ct.room);
      if (ct && ct.room) {
          let parts = ct.room.split("/");
          this.$router.push({
            name: "room",
            params: {
              acc: parts[0],
              uid: parts[1]
            }
          });
      }
      if (ct.raw && ct.raw.tagx) {
        let tgx = ct.raw.tagx;
        if (tgx.nick) {
          let uid = tgx.nick;
          this.$router.push({
            name: "room",
            params: {
              acc: vx.acc,
              uid: uid
            }
          });
        }
      }
    }
  },
  beforeDestroy() {
    // eslint-disable-next-line 
    console.log("home destroy");
    if (window.vxHome) { window.vxHome.cleanup(); }
    this.removeLegacyScripts();
    this.$parent.set_background();
    vxslog({p:"home",a:"leave"});
  }
};
</script>
<style lang="scss">
body,
.root {
  margin: 0;
  padding: 0;
}

.vxwpp_h {
  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNjAiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIxNDQuMTczIDEwMy42NzMgMTYwIDI1NiI+PHJlY3QgeD0iMTQ0LjE3MyIgeT0iMTAzLjY3MyIgd2lkdGg9IjE2MCIgaGVpZ2h0PSIyNTYiIGZpbGwtb3BhY2l0eT0iMC4yIi8+PHBhdGggZD0iTTE1OS41MzIgMjMxLjkyM2MwLTQuMDQ5IDEuNTQ2LTguMDk4IDQuNjMyLTExLjE4NWw5Ny4xNDMtOTcuMTQyYzYuMTgtNi4xOCAxNi4xOTktNi4xOCAyMi4zNzYgMCA2LjE3NyA2LjE3NiA2LjE3NyAxNi4xOTMgMCAyMi4zNzNsLTg1Ljk1OCA4NS45NTMgODUuOTU1IDg1Ljk1M2M2LjE3NyA2LjE4IDYuMTc3IDE2LjE5NSAwIDIyLjM3MiAtNi4xNzcgNi4xODItMTYuMTk2IDYuMTgyLTIyLjM3NiAwbC05Ny4xNDMtOTcuMTQxQzE2MS4wNzUgMjQwLjAxOSAxNTkuNTMyIDIzNS45NyAxNTkuNTMyIDIzMS45MjN6IiBzdHlsZT0iZmlsbDojRkZGO3N0cm9rZS13aWR0aDo4O3N0cm9rZTojODA4MDgwIi8+PC9zdmc+")
    no-repeat center;
  background-size: 100%;
  width: 4%;
  height: 100%;
  left: 1%;
  top: 0;
}

.vxwnp_h {
  background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNjAiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIxNDQuMTczIDEwMy42NzMgMTYwIDI1NiI+PHJlY3QgeD0iMTQ0LjE3MyIgeT0iMTAzLjY3MyIgd2lkdGg9IjE2MCIgaGVpZ2h0PSIyNTYiIGZpbGwtb3BhY2l0eT0iMC4yIi8+PHBhdGggZD0iTTI4OC4zMTUgMjMxLjkyM2MwIDQuMDQ5LTEuNTQ2IDguMDk4LTQuNjMyIDExLjE4NWwtOTcuMTQzIDk3LjE0MmMtNi4xOCA2LjE4LTE2LjE5OSA2LjE4LTIyLjM3NiAwIC02LjE3Ny02LjE3Ni02LjE3Ny0xNi4xOTMgMC0yMi4zNzNsODUuOTU4LTg1Ljk1MyAtODUuOTU1LTg1Ljk1M2MtNi4xNzctNi4xOC02LjE3Ny0xNi4xOTUgMC0yMi4zNzIgNi4xNzctNi4xODIgMTYuMTk2LTYuMTgyIDIyLjM3NiAwbDk3LjE0MyA5Ny4xNDFDMjg2Ljc3MiAyMjMuODI4IDI4OC4zMTUgMjI3Ljg3NiAyODguMzE1IDIzMS45MjN6IiBzdHlsZT0iZmlsbDojRkZGO3N0cm9rZS13aWR0aDo4O3N0cm9rZTojODA4MDgwIi8+PC9zdmc+")
    no-repeat center;
  background-size: 100%;
  width: 4%;
  height: 100%;
  right: 1%;
  top: 0;
}

/* ============================== */

.header {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  flex-flow: row;
  align-items: start;
  background-color: rgba(255, 255, 255, 0.2);
  color: #ebffff;
  padding: 3px 3px;
  font-family: "Roboto Condensed", sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.content,
.flex_fill {
  flex: 1 1 0;
}

.content {
  position: relative;
}

#home_wall {
  position: relative;
  width: 100%;
  height: 100%;
  opacity: 1;
}

#home_wall .vxwclb {
  display: none;
}

#home_wall .hm_cats {
  position: absolute;
  top:0;
  left:0;
  z-index: 10;
}

#home_wall .hm_cat {
  border-radius:7px;
  margin-right: 3px;
  padding: 3px 5px;
  background-color:rgba(0,80,80,0.65);
  font-size: 1.3vw;
  letter-spacing: 0.1vw;
  color:white;
  cursor:pointer;
}

#home_wall .hm_panel {
  position: absolute;
  width:100%;
  bottom:0;
  z-index: 10;
}
#home_wall .hm_panel:hover {
}

#home_wall .hm_paneli {
  position: relative;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  height:100%;
  /*width:100%;*/
  overflow:hidden;
  background-color:rgba(0,0,0,0.7);
}

.hm_panel .hm_panel_top {
  position: relative;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  flex:2;
}

.hm_panel .hm_panel_bot {
  display:none;
  position: relative;
  flex:1;
  padding:5px;
}
.hm_panel[isactive=true] .hm_panel_bot {
  display:block;
}

.hm_panel .hm_panel_left {
  position: relative;
  flex:0;
  flex-basis: 12vw;
}
.hm_panel[isactive=true] .hm_panel_left {
  /*flex:2;*/
}

.hm_panel .hm_panel_right {
  position: relative;
  flex:2.5;
  padding:5px;
}
.hm_panel[isactive=true] .hm_panel_right {
  /*flex:3;*/
}

.hm_panel_left img {
  max-width:100%;
  max-height:8vw;  
}
.hm_panel[isactive=true] .hm_panel_left img {
  max-width:100%;
  max-height:100%;
}

.hm_panel .hm_panel_rm {
  position: absolute;
  top:0;
  padding: 0 0.5vh;
  font-weight:600;
  font-size: 1.5vw;
  letter-spacing: 0.1vw;
  color:white;
  text-shadow: -2px 2px 0 #000,2px 2px 0 #000,1px -1px 0 #000,-1px -1px 0 #000;
}
.hm_panel[isactive=true] .hm_panel_rm {
  font-size: 2vw;
}

.hm_panel .hm_panel_cat {
  font-size: 2.2vmin;
  color:red;
}
.hm_panel[isactive=true] .hm_panel_cat {
  text-align: center;
  font-size: 2.5vmin;
}

.hm_panel .hm_panel_tt {  
  font-size: 1.5em;
  font-weight:600;
  color:#36ccc8;
}
.hm_panel[isactive=true] .hm_panel_tt {
}

.hm_panel .hm_panel_nm {  
  font-size: 1.3em;
  font-weight:400;
  color:white;
}
.hm_panel[isactive=true] .hm_panel_nm {
  font-size: 1.5em;
}

.hm_panel .hm_panel_loc {
  font-size: 1em;
  font-weight:400;
  color:#ffffff;
}
.hm_panel[isactive=true] .hm_panel_loc {
  font-size: 1.2em;
}

.hm_panel .hm_panel_descr {
  display:none;
}
.hm_panel[isactive=true] .hm_panel_descr {
  display:block;
  font-size: 1.2em;
  text-decoration: underline;
  color: #60b0ff;
  cursor:pointer;
}

.hm_panel .hm_panel_url {
  display:none;
}
.hm_panel[isactive=true] .hm_panel_url {
  display:block;
  text-align:center;
  font-size: 1.2em;
  text-decoration: underline;
  color: #2070ff;
}

.pg_home {
  /*margin: 0 0.5rem;*/
  background-color:rgba(0,0,0,0.6);
  border-radius: 5px;
  height: 4rem;
  width: 1.5rem;
}

.home_alert {
  position:absolute;
  z-index:1;
  top:0;
  left:5%;
  padding:10px;
  color:white;  
}

@media screen and (max-width:600px) and (orientation:portrait) {
  #home_wall .hm_cat {
    font-size: 2.5vw;
  }
  .hm_panel .hm_panel_tt {  
    font-size: 1.0em;
  }
  .hm_panel .hm_panel_nm {  
    font-size: 0.8em;
  }
  .hm_panel[isactive=true] .hm_panel_nm {
    font-size: 0.85em;
  }
  .hm_panel .hm_panel_loc {
    font-size: 0.6em;
  }
  .hm_panel[isactive=true] .hm_panel_loc {
    font-size: 0.65em;
  }
  .hm_panel[isactive=true] .hm_panel_descr {
    font-size: 0.7em;
  }
}

</style>
